export enum PulseValueEnum {
	positive = 'positive',
	negative = 'negative',
	unknown = 'unknown'
}

export enum PulseArteriesEnum {
	dorsalisPedisLeft = 'dorsalisPedisLeft',
	dorsalisPedisRight = 'dorsalisPedisRight',
	posteriorTibialLeft = 'posteriorTibialLeft',
	posteriorTibialRight = 'posteriorTibialRight'
}

export enum PulseEnum {
	Pulse = 'pulse',
	Dx = 'dx',
	Sin = 'sin',
	DorsalisPedis = 'dorsalisPedis',
	TibialisPosterior = 'tibialisPosterior',
}

export const PulseTranslations: Record<PulseEnum, { en: string[]; da: string[] }> = {
	[PulseEnum.Pulse]: {
		en: ['Pulse'],
		da: ['Puls'],
	},
	[PulseEnum.Dx]: {
		en: ['dx.'],
		da: ['dx'],
	},
	[PulseEnum.Sin]: {
		en: ['sin.'],
		da: ['sin'],
	},
	[PulseEnum.DorsalisPedis]: {
		en: ['A Dorsalis Pedis'],
		da: ['Dorsal pedis'],
	},
	[PulseEnum.TibialisPosterior]: {
		en: ['A Tibialis Posterior'],
		da: ['A Tibialis Posterior'],
	},
};
